import CardConnection from '@/operator/components/general/cards/CardConnection';
import { appRoutes } from 'app/routes/constants';
import { ListedConnection } from '@/operator/components/modules/connections/types/listedConnection';
import { upperFirst } from 'lodash';
import React from 'react';
import { useOrgNavigate } from "app/routes/useOrgNavigate";

interface ConnectionListProps {
    availableConnections: ListedConnection[];
}

const ConnectionList: React.FC<ConnectionListProps> = ({
    availableConnections,
}) => {
    const navigate = useOrgNavigate();

    return availableConnections.map(
        ({ connection, connected, organizationId }) => {
            return (
                <CardConnection
                    key={connection}
                    connected={connected}
                    onClick={() =>
                        navigate(
                            connected
                                ? `${appRoutes.OPERATOR_ADMIN_CONNECTIONS_SETTINGS}?id=${organizationId}&label=${connection}`
                                : `${appRoutes.OPERATOR_ADMIN_CONNECTIONS_ADD}?label=${connection}`,
                        )
                    }
                    label={`${connected
                        ? `${upperFirst(connection)} connected`
                        : `Connect ${upperFirst(connection)}`
                        }`}
                    imgSrc={require(
                        `../../../operator-app/public/assets/images/connections/${connection.toLowerCase()}-card.svg`,
                    )}
                />
            );
        },
    );
};

export default ConnectionList;
